module.exports = __webpack_public_path__ + "img/travel3.02e680ee.jpg";